import * as React from "react";
import { connect } from "react-redux";
import { TopBar, TopBarColumn } from "../Topbar";
import { TEST_ROUTE } from "../../../views/routes";
import { RootState } from "../../../store";
import { Profile } from "../../../views/profile/api/types";
import { HomeButton } from "../Button/HomeButton";
import { ProfileItem } from "../ProfileItem";
import { StyledNavigatorTest } from "./StyledNavBar";
import testButtonSvg from "../../../assets/icons/test_button.svg?url";
import XcAudioSL from "../../../external/EddaXcomp/src/components/BlockLoader/ExerciseComponents/XcAudio/XcAudioStateless";
import { toggleAudioOverlay } from "../../containers/SoundWrapper/store/actions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { StyledTipContainer } from "../Card/StyledCard";
import { Tooltip } from "../Tooltip";
import {
  EXERCISE_ROUTE,
  ADVENTURE_STORY_ROUTE,
  ADVENTURE_PICKER_ROUTE
} from "../../../views/routes";
import { selectCurrentRoute } from "../../store/router/selectors";
export interface NavBarProps {
  centerPiece?: JSX.Element | null;
  position?: string;
  progressBarValue?: number;
  hideHomeBtn?: boolean;
  hideAudioButton?: boolean;
  children?: React.ReactNode;
}

export interface ReduxProps {
  profile: Profile;
}

export type OwnProps = NavBarProps & ReduxProps;

const NavBarComponent: React.FC<OwnProps> = (props) => {
  const icon = <img src={testButtonSvg} alt="" />;
  const dispatch = useDispatch();

  const [audioTooltipShown, setAudioTooltipShown] = React.useState(false);

  const audioOverlayActive = useSelector(
    (state: RootState) => state.audio.audioOverlayActive
  );
  const playSound = React.useCallback(() => dispatch(toggleAudioOverlay()), [dispatch]);

  const currentRoute = useSelector(selectCurrentRoute);

  const handleShowTooltip = () => {
    setAudioTooltipShown(true);
  };

  // Only show the audio button on certain routes, as it is only relevant there.
  const AUDIO_BUTTON_ROUTES = new Set([
    EXERCISE_ROUTE,
    ADVENTURE_STORY_ROUTE,
    ADVENTURE_PICKER_ROUTE,
  ]);

  const showAudioButton =
    !props.hideAudioButton && AUDIO_BUTTON_ROUTES.has(currentRoute as string);

  return (
    <TopBar position={props.position}>
      <TopBarColumn alignment="left">
        {props.hideHomeBtn || <HomeButton />}
        {props.children}
      </TopBarColumn>

      <TopBarColumn alignment="center">{props.centerPiece}</TopBarColumn>

      <TopBarColumn alignment="right">
        {showAudioButton && (
          <>
            <XcAudioSL callback={playSound} active={audioOverlayActive} />

            <StyledTipContainer>
              <Tooltip
                show={audioOverlayActive && !audioTooltipShown}
                text="Tryck på markerad text för att lyssna på ljud"
                right="-4px"
                top="78px"
                arrowPosition="top"
                removeTime={4000}
                callback={() => handleShowTooltip()}
              />
            </StyledTipContainer>
          </>
        )}

        {props.profile.is_test && (
          <StyledNavigatorTest route={TEST_ROUTE} icon={icon} />
        )}
        <ProfileItem
          name={props.profile.first_name}
          picture={props.profile.picture}
          backPlate={true}
        />
      </TopBarColumn>
    </TopBar>
  );
};

const mapStateToProps = (state: RootState): ReduxProps => ({
  profile: state.profile.profile,
});

export const NavBar = connect(mapStateToProps, {})(NavBarComponent);
